import React, { useState, useMemo } from 'react'
import {ArrowLeft, Search, Thermometer, Leaf, ChevronDown, ChevronUp, Download, Info, Calculator, Filter, X} from 'lucide-react'
import { motion, AnimatePresence } from 'framer-motion'

interface GDDCalculatorProps {
  onBack: () => void
}

interface Crop {
  group: string
  type: string
  crop: string
  tbase: number
  tupper: number
}

// Datos completos de cultivos FAO
const cropDataset: Crop[] = [
  // Vegetable crops / Roots, tubers...
  { group: "Vegetable crops", type: "Roots, tubers, bulbs and steam vegetable crops", crop: "Asparagus (Asparagus officinalis)", tbase: 4.5, tupper: 35.0 },
  { group: "Vegetable crops", type: "Roots, tubers, bulbs and steam vegetable crops", crop: "Carrots (Daucus carota)", tbase: 6.0, tupper: 30.0 },
  { group: "Vegetable crops", type: "Roots, tubers, bulbs and steam vegetable crops", crop: "Cassava (Manihot esculenta)", tbase: 10.0, tupper: 40.0 },
  { group: "Vegetable crops", type: "Roots, tubers, bulbs and steam vegetable crops", crop: "Celery (Apium graveolens)", tbase: 4.0, tupper: 24.0 },
  { group: "Vegetable crops", type: "Roots, tubers, bulbs and steam vegetable crops", crop: "Garlic (Allium sativum)", tbase: 4.0, tupper: 30.0 },
  { group: "Vegetable crops", type: "Roots, tubers, bulbs and steam vegetable crops", crop: "Onions (Allium cepa)", tbase: 4.5, tupper: 35.0 },
  { group: "Vegetable crops", type: "Roots, tubers, bulbs and steam vegetable crops", crop: "Potato (Solanum tuberosum)", tbase: 2.0, tupper: 30.0 },
  { group: "Vegetable crops", type: "Roots, tubers, bulbs and steam vegetable crops", crop: "Radish (Raphanus sativus)", tbase: 4.5, tupper: 30.0 },
  { group: "Vegetable crops", type: "Roots, tubers, bulbs and steam vegetable crops", crop: "Sweet potato (Ipomoea batatas)", tbase: 12.0, tupper: 30.0 },
  { group: "Vegetable crops", type: "Roots, tubers, bulbs and steam vegetable crops", crop: "Table beets (Beta vulgaris)", tbase: 4.5, tupper: 30.0 },
  { group: "Vegetable crops", type: "Roots, tubers, bulbs and steam vegetable crops", crop: "Turnip (Brassica rapa)", tbase: 4.0, tupper: 35.0 },
  { group: "Vegetable crops", type: "Roots, tubers, bulbs and steam vegetable crops", crop: "Yam, Taro (Colocasia esculenta)", tbase: 10.0, tupper: 35.0 },
  { group: "Vegetable crops", type: "Leaves and flowers vegetable crops", crop: "Artichoke (Cynara scolymus)", tbase: 5.0, tupper: 32.0 },
  { group: "Vegetable crops", type: "Leaves and flowers vegetable crops", crop: "Broccoli (Brassica oleracea var. italica)", tbase: 4.5, tupper: 30.0 },
  { group: "Vegetable crops", type: "Leaves and flowers vegetable crops", crop: "Brussel sprouts (B. oleracea cv. gemmifera)", tbase: 4.5, tupper: 30.0 },
  { group: "Vegetable crops", type: "Leaves and flowers vegetable crops", crop: "Cabbage (B. oleracea)", tbase: 4.5, tupper: 30.0 },
  { group: "Vegetable crops", type: "Leaves and flowers vegetable crops", crop: "Cauliflower (B. oleracea cv. botrytis)", tbase: 4.5, tupper: 30.0 },
  { group: "Vegetable crops", type: "Leaves and flowers vegetable crops", crop: "Lettuce (Lactuca sativa)", tbase: 4.0, tupper: 28.0 },
  { group: "Vegetable crops", type: "Leaves and flowers vegetable crops", crop: "Spinach (Spinacia oleracea)", tbase: 4.0, tupper: 25.0 },
  { group: "Vegetable crops", type: "Fruit vegetable crops", crop: "Banana (Musa accuminata)", tbase: 14.0, tupper: 37.0 },
  { group: "Vegetable crops", type: "Fruit vegetable crops", crop: "Bell & Chili pepper (Capsicum annuum)", tbase: 10.0, tupper: 35.0 },
  { group: "Vegetable crops", type: "Fruit vegetable crops", crop: "Cucumber (Cucumis sativus)", tbase: 10.0, tupper: 32.0 },
  { group: "Vegetable crops", type: "Fruit vegetable crops", crop: "Eggplant (Solanum melongena)", tbase: 10.0, tupper: 35.0 },
  { group: "Vegetable crops", type: "Fruit vegetable crops", crop: "Melon (Cucumis melo)", tbase: 10.0, tupper: 38.0 },
  { group: "Vegetable crops", type: "Fruit vegetable crops", crop: "Melon, cantaloupe (Cucumis melo)", tbase: 10.0, tupper: 38.0 },
  { group: "Vegetable crops", type: "Fruit vegetable crops", crop: "Okra (Abelmoschus esculentus)", tbase: 10.0, tupper: 35.0 },
  { group: "Vegetable crops", type: "Fruit vegetable crops", crop: "Pineapple (Ananas comosus)", tbase: 13.0, tupper: 25.0 },
  { group: "Vegetable crops", type: "Fruit vegetable crops", crop: "Pumpkin (Cucurbita argyrosperma)", tbase: 10.0, tupper: 32.0 },
  { group: "Vegetable crops", type: "Fruit vegetable crops", crop: "Squash, Zucchini (Cucurbita pepo)", tbase: 10.0, tupper: 32.0 },
  { group: "Vegetable crops", type: "Fruit vegetable crops", crop: "Strawberries (Fragaria × ananassa)", tbase: 3.0, tupper: 30.0 },
  { group: "Vegetable crops", type: "Fruit vegetable crops", crop: "Tomato (Solanum lycopersicum)", tbase: 7.0, tupper: 28.0 },
  { group: "Vegetable crops", type: "Fruit vegetable crops", crop: "Watermelon (Citrullus lanatus)", tbase: 10.0, tupper: 35.0 },
  { group: "Vegetable crops", type: "Spicy and medicinal herbs", crop: "Basil (Ocimum basilicum)", tbase: 10.0, tupper: 30.0 },
  { group: "Vegetable crops", type: "Spicy and medicinal herbs", crop: "Black cumin (Nigella sativa)", tbase: 5.0, tupper: 30.0 },
  { group: "Vegetable crops", type: "Spicy and medicinal herbs", crop: "Black pepper (Piper nigrum)", tbase: 10.0, tupper: 40.0 },
  { group: "Vegetable crops", type: "Spicy and medicinal herbs", crop: "Coriander (Coriandrum sativum)", tbase: 4.0, tupper: 30.0 },
  { group: "Vegetable crops", type: "Spicy and medicinal herbs", crop: "Fenugreek (Trigonella foenum-graecum)", tbase: 4.0, tupper: 35.0 },
  { group: "Vegetable crops", type: "Spicy and medicinal herbs", crop: "Lemon balm (Melissa officinalis)", tbase: 5.0, tupper: 35.0 },
  { group: "Vegetable crops", type: "Spicy and medicinal herbs", crop: "Mint (Mentha spicata)", tbase: 4.0, tupper: 35.0 },
  { group: "Vegetable crops", type: "Spicy and medicinal herbs", crop: "Oregano (Origanum vulgare)", tbase: 5.0, tupper: 30.0 },
  { group: "Vegetable crops", type: "Spicy and medicinal herbs", crop: "Parsley (Petroselinum crispum)", tbase: 4.0, tupper: 27.0 },
  { group: "Vegetable crops", type: "Spicy and medicinal herbs", crop: "Saffron (Crocus sativus)", tbase: 10.0, tupper: 30.0 },
  { group: "Field crops", type: "Grain legumes", crop: "Bean (Phaseolus vulgaris)", tbase: 10.0, tupper: 32.0 },
  { group: "Field crops", type: "Grain legumes", crop: "Mungbean (Vigna radiata)", tbase: 8.0, tupper: 40.0 },
  { group: "Field crops", type: "Grain legumes", crop: "Black and green gram (Vigna mungo)", tbase: 10.0, tupper: 40.0 },
  { group: "Field crops", type: "Grain legumes", crop: "Chickpea, garbanzo (Cicer arietinum)", tbase: 5.0, tupper: 32.0 },
  { group: "Field crops", type: "Grain legumes", crop: "Cowpea (Vigna unguiculata)", tbase: 10.0, tupper: 35.0 },
  { group: "Field crops", type: "Grain legumes", crop: "Fava bean (Vicia faba)", tbase: 5.0, tupper: 30.0 },
  { group: "Field crops", type: "Grain legumes", crop: "Groundnut, peanut (Arachis hypogaea)", tbase: 10.0, tupper: 35.0 },
  { group: "Field crops", type: "Grain legumes", crop: "Lentil (Lens culinaris)", tbase: 2.0, tupper: 35.0 },
  { group: "Field crops", type: "Grain legumes", crop: "Pea (Pisum sativum)", tbase: 5.0, tupper: 27.0 },
  { group: "Field crops", type: "Grain legumes", crop: "Soybean (Glycine max)", tbase: 10.0, tupper: 40.0 },
  { group: "Field crops", type: "Fiber crops", crop: "Cotton (Gossypium hirsutum)", tbase: 12.5, tupper: 35.0 },
  { group: "Field crops", type: "Fiber crops", crop: "Flax, Linseed (Linum usitatissimum)", tbase: 0.0, tupper: 36.0 },
  { group: "Field crops", type: "Fiber crops", crop: "Sisal (Agave sisalana)", tbase: 10.0, tupper: 35.0 },
  { group: "Field crops", type: "Oil crops", crop: "Camelina (Camelina sativa)", tbase: 4.0, tupper: 30.0 },
  { group: "Field crops", type: "Oil crops", crop: "Canola (Brassica napus)", tbase: 2.0, tupper: 30.0 },
  { group: "Field crops", type: "Oil crops", crop: "Castorbean (Ricinus communis)", tbase: 10.0, tupper: 30.0 },
  { group: "Field crops", type: "Oil crops", crop: "Guar (Cyamopsis tetragonoloba)", tbase: 15.0, tupper: 40.0 },
  { group: "Field crops", type: "Oil crops", crop: "Mustard (Brassica juncea)", tbase: 5.0, tupper: 40.0 },
  { group: "Field crops", type: "Oil crops", crop: "Safflower (Carthamus tinctorius)", tbase: 5.0, tupper: 35.0 },
  { group: "Field crops", type: "Oil crops", crop: "Sesame (Sesamum indicum)", tbase: 10.0, tupper: 40.0 },
  { group: "Field crops", type: "Oil crops", crop: "Sunflower (Helianthus annuus)", tbase: 8.0, tupper: 30.0 },
  { group: "Field crops", type: "Sugar crops", crop: "Sugar beet (Beta vulgaris)", tbase: 5.0, tupper: 30.0 },
  { group: "Field crops", type: "Sugar crops", crop: "Sugar cane (Saccharum officinarum)", tbase: 10.0, tupper: 45.0 },
  { group: "Field crops", type: "Cereals and pseudocereals", crop: "Amaranth grain (Amaranthus sp.)", tbase: 7.0, tupper: 40.0 },
  { group: "Field crops", type: "Cereals and pseudocereals", crop: "Barley (Hordeum vulgare)", tbase: 0.0, tupper: 30.0 },
  { group: "Field crops", type: "Cereals and pseudocereals", crop: "Maize (Zea mays)", tbase: 10.0, tupper: 32.0 },
  { group: "Field crops", type: "Cereals and pseudocereals", crop: "Oats (Avena sativa)", tbase: 0.0, tupper: 30.0 },
  { group: "Field crops", type: "Cereals and pseudocereals", crop: "Pearl Millet (Pennisetum glaucum)", tbase: 10.0, tupper: 40.0 },
  { group: "Field crops", type: "Cereals and pseudocereals", crop: "Quinoa (Chenopodium quinoa)", tbase: 2.0, tupper: 25.0 },
  { group: "Field crops", type: "Cereals and pseudocereals", crop: "Rye (Secale cereale)", tbase: 4.0, tupper: 35.0 },
  { group: "Field crops", type: "Cereals and pseudocereals", crop: "Sorghum (Sorghum bicolor)", tbase: 10.0, tupper: 30.0 },
  { group: "Field crops", type: "Cereals and pseudocereals", crop: "Teff (Eragrostis tef)", tbase: 10.0, tupper: 30.0 },
  { group: "Field crops", type: "Cereals and pseudocereals", crop: "Wheat, common (Triticum aestivum)", tbase: 0.0, tupper: 35.0 },
  { group: "Field crops", type: "Cereals and pseudocereals", crop: "Wheat, durum (Triticum durum)", tbase: 0.0, tupper: 35.0 },
  { group: "Field crops", type: "Cereals and pseudocereals", crop: "Rice (Oryza sativa)", tbase: 12.0, tupper: 35.0 },
  { group: "Field crops", type: "Grasses", crop: "Alfalfa (Medicago sativa)", tbase: 0.0, tupper: 30.0 },
  { group: "Field crops", type: "Grasses", crop: "Bermuda (Cynodon dactylon)", tbase: 10.0, tupper: 30.0 },
  { group: "Field crops", type: "Grasses", crop: "Berseem clover (Trifolium alexandrinum)", tbase: 4.0, tupper: 30.0 },
  { group: "Field crops", type: "Grasses", crop: "Common vetch (Vicia sativa)", tbase: 0.0, tupper: 30.0 },
  { group: "Field crops", type: "Grasses", crop: "Elephant grass (Pennisetum sp.)", tbase: 15.0, tupper: 40.0 },
  { group: "Field crops", type: "Grasses", crop: "Grass pastures", tbase: 4.0, tupper: 30.0 },
  { group: "Field crops", type: "Grasses", crop: "Guinea grass (Panicum maximum)", tbase: 14.0, tupper: 40.0 },
  { group: "Field crops", type: "Grasses", crop: "Hairy vetch (Vicia villosa)", tbase: 2.0, tupper: 25.0 },
  { group: "Field crops", type: "Grasses", crop: "Italian ryegrass (Lolium multiflorum)", tbase: 2.0, tupper: 25.0 },
  { group: "Field crops", type: "Grasses", crop: "Persian clover (Trifolium resupinatum)", tbase: 6.0, tupper: 35.0 },
  { group: "Field crops", type: "Grasses", crop: "Sudan grass (Sorghum × drummondii)", tbase: 10.0, tupper: 35.0 },
  { group: "Trees, shrubs, and vines", type: "Mediterranean and warm temperate climates fruit trees and vines", crop: "Olive (Olea europaea)", tbase: 7.0, tupper: 35.0 },
  { group: "Trees, shrubs, and vines", type: "Mediterranean and warm temperate climates fruit trees and vines", crop: "Wine and table grapes (Vitis vinifera)", tbase: 10.0, tupper: 35.0 },
  { group: "Trees, shrubs, and vines", type: "Mediterranean and warm temperate climates fruit trees and vines", crop: "Citrus (Citrus sp.)", tbase: 13.0, tupper: 30.0 },
  { group: "Trees, shrubs, and vines", type: "Mediterranean and warm temperate climates fruit trees and vines", crop: "Avocado (Persea americana)", tbase: 6.0, tupper: 33.0 },
  { group: "Trees, shrubs, and vines", type: "Mediterranean and warm temperate climates fruit trees and vines", crop: "Loquat (Eriobotrya japonica)", tbase: 4.0, tupper: 42.0 },
  { group: "Trees, shrubs, and vines", type: "Mediterranean and warm temperate climates fruit trees and vines", crop: "Pomegranate (Punica granatum)", tbase: 10.0, tupper: 35.0 },
  { group: "Temperate climate fruit trees, vines and shrubs", type: "Pomme fruit trees", crop: "Apple (Malus domestica)", tbase: 4.0, tupper: 35.0 },
  { group: "Temperate climate fruit trees, vines and shrubs", type: "Pomme fruit trees", crop: "Pear (Pyrus communis)", tbase: 4.0, tupper: 35.0 },
  { group: "Temperate climate fruit trees, vines and shrubs", type: "Stone fruit trees", crop: "Apricot (Prunus armeniaca)", tbase: 7.0, tupper: 25.0 },
  { group: "Temperate climate fruit trees, vines and shrubs", type: "Stone fruit trees", crop: "Cherry (Prunus avium)", tbase: 4.5, tupper: 30.0 },
  { group: "Temperate climate fruit trees, vines and shrubs", type: "Stone fruit trees", crop: "Peach and nectarine (Prunus persica)", tbase: 7.0, tupper: 35.0 },
  { group: "Temperate climate fruit trees, vines and shrubs", type: "Stone fruit trees", crop: "Plum (P. domestica and P. salicina)", tbase: 4.5, tupper: 25.0 },
  { group: "Temperate climate fruit trees, vines and shrubs", type: "Nut fruit trees", crop: "Almond (Prunus dulcis)", tbase: 4.5, tupper: 35.0 },
  { group: "Temperate climate fruit trees, vines and shrubs", type: "Nut fruit trees", crop: "Pistachio (Pistacia vera)", tbase: 9.0, tupper: 35.0 },
  { group: "Temperate climate fruit trees, vines and shrubs", type: "Nut fruit trees", crop: "Walnut (Juglans regia)", tbase: 4.5, tupper: 30.0 },
  { group: "Temperate climate fruit trees, vines and shrubs", type: "Other temperate vines and shrubs", crop: "Kiwifruit (Actinidia deliciosa)", tbase: 6.0, tupper: 30.0 },
  { group: "Temperate climate fruit trees, vines and shrubs", type: "Other temperate vines and shrubs", crop: "Hop (Humulus lupulus)", tbase: 5.0, tupper: 30.0 },
  { group: "Temperate climate fruit trees, vines and shrubs", type: "Other temperate vines and shrubs", crop: "Berries (Vaccinium sp.)", tbase: 6.0, tupper: 30.0 },
  { group: "Temperate climate fruit trees, vines and shrubs", type: "Sub–tropical and tropical small fruit trees and shrub", crop: "Coffee (Coffea arabica)", tbase: 10.0, tupper: 32.0 },
  { group: "Temperate climate fruit trees, vines and shrubs", type: "Sub–tropical and tropical small fruit trees and shrub", crop: "Guava (Psidium guajava)", tbase: 12.0, tupper: 35.0 },
  { group: "Temperate climate fruit trees, vines and shrubs", type: "Sub–tropical and tropical small fruit trees and shrub", crop: "Papaya (Carica papaya)", tbase: 15.0, tupper: 35.0 },
  { group: "Temperate climate fruit trees, vines and shrubs", type: "Sub–tropical and tropical small fruit trees and shrub", crop: "Passionfruit (Passiflora edulis)", tbase: 10.0, tupper: 35.0 },
  { group: "Temperate climate fruit trees, vines and shrubs", type: "Tropical fruit trees", crop: "Lychee (Litchi chinensis)", tbase: 10.0, tupper: 30.0 },
  { group: "Temperate climate fruit trees, vines and shrubs", type: "Tropical fruit trees", crop: "Mango (Mangifera indica)", tbase: 12.0, tupper: 32.0 },
  { group: "Temperate climate fruit trees, vines and shrubs", type: "Palm plantations", crop: "Date palm (Phoenix dactylifera)", tbase: 10.0, tupper: 35.0 },
  { group: "Temperate climate fruit trees, vines and shrubs", type: "Palm plantations", crop: "Oil palm (Elaeis guineensis)", tbase: 15.0, tupper: 40.0 }
]

// Grupos disponibles para el filtro
const availableGroups = [
  "Vegetable crops",
  "Field crops",
  "Trees, shrubs, and vines",
  "Temperate climate fruit trees, vines and shrubs"
]

const GDDCalculator: React.FC<GDDCalculatorProps> = ({ onBack }) => {
  const [selectedGroup, setSelectedGroup] = useState<string>("all")
  const [searchTerm, setSearchTerm] = useState<string>("")
  const [selectedCrop, setSelectedCrop] = useState<Crop | null>(null)
  const [showCalculator, setShowCalculator] = useState<boolean>(false)
  const [dailyTemperatures, setDailyTemperatures] = useState<string>("")
  const [gddResult, setGddResult] = useState<number | null>(null)
  const [expandedRows, setExpandedRows] = useState<Set<number>>(new Set())
  const [isFilterOpen, setIsFilterOpen] = useState<boolean>(false)

  // Filtrar cultivos según grupo y término de búsqueda
  const filteredCrops = useMemo(() => {
    return cropDataset.filter(crop => {
      const matchesGroup = selectedGroup === "all" || crop.group === selectedGroup
      const matchesSearch = searchTerm === "" || crop.crop.toLowerCase().includes(searchTerm.toLowerCase())
      return matchesGroup && matchesSearch
    })
  }, [selectedGroup, searchTerm])

  // Función para calcular GDD a partir de temperaturas diarias
  const calculateGDD = (crop: Crop, temps: number[]): number => {
    let totalGDD = 0
    for (const temp of temps) {
      let effectiveTemp = temp - crop.tbase
      if (effectiveTemp < 0) effectiveTemp = 0
      if (effectiveTemp > crop.tupper - crop.tbase) effectiveTemp = crop.tupper - crop.tbase
      totalGDD += effectiveTemp
    }
    return Math.round(totalGDD * 10) / 10
  }

  // Manejar cálculo
  const handleCalculateGDD = () => {
    if (!selectedCrop) return
    const temps = dailyTemperatures.split(",").map(t => parseFloat(t.trim())).filter(t => !isNaN(t))
    if (temps.length === 0) {
      alert("Ingresa temperaturas válidas separadas por comas (ej: 22, 24, 23.5, 21)")
      return
    }
    const result = calculateGDD(selectedCrop, temps)
    setGddResult(result)
  }

  // Exportar datos a CSV
  const exportToCSV = () => {
    const headers = ["Crop", "Group", "Type", "Tbase (°C)", "Tupper (°C)"]
    const rows = filteredCrops.map(c => [c.crop, c.group, c.type, c.tbase, c.tupper])
    const csvContent = [headers, ...rows].map(row => row.join(",")).join("\n")
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
    const link = document.createElement("a")
    const url = URL.createObjectURL(blob)
    link.href = url
    link.setAttribute("download", "fao_gdd_crops.csv")
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  // Toggle fila expandida
  const toggleRow = (index: number) => {
    const newExpanded = new Set(expandedRows)
    if (newExpanded.has(index)) {
      newExpanded.delete(index)
    } else {
      newExpanded.add(index)
    }
    setExpandedRows(newExpanded)
  }

  // Limpiar filtros
  const clearFilters = () => {
    setSelectedGroup("all")
    setSearchTerm("")
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-teal-50 to-green-50">
      {/* Header con botón de regreso */}
      <div className="bg-white/80 backdrop-blur-sm border-b border-emerald-100 sticky top-0 z-10 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <button
            onClick={onBack}
            className="flex items-center gap-2 text-emerald-700 hover:text-emerald-900 transition-colors font-medium"
          >
            <ArrowLeft className="w-5 h-5" />
            Volver
          </button>
          <h1 className="text-xl font-bold text-emerald-800 flex items-center gap-2">
            <Thermometer className="w-6 h-6 text-orange-500" />
            GDD Calculator FAO
          </h1>
          <div className="w-20"></div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6">
        {/* Tarjeta de información */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-gradient-to-r from-emerald-600 to-teal-600 rounded-2xl p-6 text-white mb-8 shadow-lg"
        >
          <div className="flex items-start gap-4 flex-wrap justify-between">
            <div>
              <h2 className="text-2xl font-bold mb-2">Grados Día de Desarrollo</h2>
              <p className="text-emerald-100 max-w-2xl">
                Los GDD (Growing Degree Days) son una medida de acumulación térmica que ayuda a predecir 
                etapas fenológicas de los cultivos. Fórmula: <strong>GDD = Σ(Tmedia - Tbase)</strong>, 
                con límite superior (Tupper).
              </p>
            </div>
            <Info className="w-10 h-10 text-emerald-200 opacity-80" />
          </div>
        </motion.div>

        {/* Filtros */}
        <div className="bg-white rounded-xl shadow-md p-5 mb-6">
          <div className="flex items-center justify-between mb-4 flex-wrap gap-3">
            <div className="flex items-center gap-2">
              <Filter className="w-5 h-5 text-emerald-600" />
              <h3 className="font-semibold text-gray-700">Filtros de búsqueda</h3>
            </div>
            <button
              onClick={clearFilters}
              className="text-sm text-emerald-600 hover:text-emerald-800 flex items-center gap-1"
            >
              <X className="w-4 h-4" />
              Limpiar filtros
            </button>
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            {/* Selector de grupo */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Grupo de cultivo</label>
              <div className="relative">
                <button
                  onClick={() => setIsFilterOpen(!isFilterOpen)}
                  className="w-full flex items-center justify-between px-4 py-2 border border-gray-300 rounded-lg bg-white hover:bg-gray-50"
                >
                  <span className="text-gray-700">
                    {selectedGroup === "all" ? "🌍 Todos los grupos" : selectedGroup}
                  </span>
                  {isFilterOpen ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
                </button>
                <AnimatePresence>
                  {isFilterOpen && (
                    <motion.div
                      initial={{ opacity: 0, y: -10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -10 }}
                      className="absolute z-20 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg"
                    >
                      <button
                        onClick={() => { setSelectedGroup("all"); setIsFilterOpen(false) }}
                        className={`w-full text-left px-4 py-2 hover:bg-emerald-50 ${selectedGroup === "all" ? "bg-emerald-100 text-emerald-800" : ""}`}
                      >
                        🌍 Todos los grupos
                      </button>
                      {availableGroups.map(group => (
                        <button
                          key={group}
                          onClick={() => { setSelectedGroup(group); setIsFilterOpen(false) }}
                          className={`w-full text-left px-4 py-2 hover:bg-emerald-50 ${selectedGroup === group ? "bg-emerald-100 text-emerald-800" : ""}`}
                        >
                          {group}
                        </button>
                      ))}
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </div>

            {/* Búsqueda por cultivo */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Buscar cultivo</label>
              <div className="relative">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Ej: Maize, Tomato, Quinoa, Coffee..."
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none"
                />
              </div>
            </div>
          </div>

          {/* Resultados del filtro */}
          {/*
          <div className="mt-4 text-sm text-gray-500 flex items-center justify-between flex-wrap gap-2">
            <span>📋 Mostrando {filteredCrops.length} de {cropDataset.length} cultivos</span>
            <button
              onClick={exportToCSV}
              className="flex items-center gap-1 text-emerald-600 hover:text-emerald-800 text-sm"
            >
              <Download className="w-4 h-4" />
              Exportar CSV
            </button>
          </div>
          */}
        </div>
        {/* Tabla de cultivos */}
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-emerald-50 border-b border-emerald-100">
                <tr>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-emerald-800">Cultivo</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-emerald-800">Grupo</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-emerald-800">Tipo</th>
                  <th className="px-4 py-3 text-center text-sm font-semibold text-emerald-800">Tbase (°C)</th>
                  <th className="px-4 py-3 text-center text-sm font-semibold text-emerald-800">Tupper (°C)</th>
                  <th className="px-4 py-3 text-center text-sm font-semibold text-emerald-800">Acción</th>
                </tr>
              </thead>
              <tbody>
                <AnimatePresence>
                  {filteredCrops.length === 0 ? (
                    <tr>
                      <td colSpan={6} className="text-center py-12 text-gray-400">
                        No se encontraron cultivos con esos criterios
                      </td>
                    </tr>
                  ) : (
                    filteredCrops.map((crop, idx) => (
                      <motion.tr
                        key={idx}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="border-b border-gray-100 hover:bg-emerald-50/50 transition-colors"
                      >
                        <td className="px-4 py-3 text-sm font-medium text-gray-800">
                          <div className="flex items-center gap-2">
                            <Leaf className="w-4 h-4 text-emerald-500" />
                            {crop.crop}
                          </div>
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-600">{crop.group}</td>
                        <td className="px-4 py-3 text-sm text-gray-500 max-w-xs truncate">{crop.type}</td>
                        <td className="px-4 py-3 text-center text-sm font-semibold text-emerald-700">{crop.tbase}°C</td>
                        <td className="px-4 py-3 text-center text-sm font-semibold text-orange-600">{crop.tupper}°C</td>
                        <td className="px-4 py-3 text-center">
                          <button
                            onClick={() => {
                              setSelectedCrop(crop)
                              setShowCalculator(true)
                              setGddResult(null)
                              setDailyTemperatures("")
                            }}
                            className="flex items-center gap-1 mx-auto bg-emerald-100 hover:bg-emerald-200 text-emerald-700 px-3 py-1.5 rounded-lg text-sm transition-colors"
                          >
                            <Calculator className="w-4 h-4" />
                            Calcular GDD
                          </button>
                        </td>
                      </motion.tr>
                    ))
                  )}
                </AnimatePresence>
              </tbody>
            </table>
          </div>
        </div>

        {/* Modal de calculadora GDD */}
        <AnimatePresence>
          {showCalculator && selectedCrop && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
              onClick={() => setShowCalculator(false)}
            >
              <motion.div
                initial={{ scale: 0.9, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.9, opacity: 0 }}
                className="bg-white rounded-2xl max-w-md w-full p-6 shadow-xl"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <h3 className="text-xl font-bold text-gray-800">{selectedCrop.crop.split("(")[0]}</h3>
                    <p className="text-sm text-gray-500">
                      Tbase: {selectedCrop.tbase}°C | Tupper: {selectedCrop.tupper}°C
                    </p>
                  </div>
                  <button onClick={() => setShowCalculator(false)} className="text-gray-400 hover:text-gray-600">
                    <X className="w-5 h-5" />
                  </button>
                </div>

                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Temperaturas medias diarias (°C)
                  </label>
                  <textarea
                    value={dailyTemperatures}
                    onChange={(e) => setDailyTemperatures(e.target.value)}
                    placeholder="Ej: 22, 24, 23.5, 21, 25, 26, 24.5"
                    rows={3}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none"
                  />
                  <p className="text-xs text-gray-400 mt-1">Separa las temperaturas con comas</p>
                </div>

                <button
                  onClick={handleCalculateGDD}
                  className="w-full bg-emerald-600 hover:bg-emerald-700 text-white py-2 rounded-lg font-medium transition-colors mb-4"
                >
                  Calcular GDD acumulado
                </button>

                {gddResult !== null && (
                  <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="bg-emerald-50 rounded-lg p-4 text-center"
                  >
                    <p className="text-sm text-emerald-600 mb-1">Grados Día de Desarrollo (GDD)</p>
                    <p className="text-3xl font-bold text-emerald-700">{gddResult} °D</p>
                    <p className="text-xs text-emerald-500 mt-2">
                      Σ (Tmedia - {selectedCrop.tbase}°C) con límite superior {selectedCrop.tupper}°C
                    </p>
                  </motion.div>
                )}
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  )
}

export default GDDCalculator
